import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { UiformBaseComponent } from '../components/uiform/uiform-base/uiform-base.component';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-public-form-component',
  templateUrl: './public-form-component.component.html',
  styleUrls: ['./public-form-component.component.scss'],
})
export class PublicFormComponentComponent
  extends UiformBaseComponent
  implements OnChanges, AfterViewInit
{
  public usecaseSchema: any = {};
  public commentList: any = [];

  public attributeId: number = 0;

  public appCommentInfo: any;
  componentFlag: boolean = true;

  isSubmitted: boolean = false;

  public entryform: any = {
    data: { id: 0 }, 
  };

  public searchform: any = {
    data: {},
  };

  isHovered: boolean = false;

  onMouseEnter() {
    this.isHovered = true;
  }

  onMouseLeave() {
    this.isHovered = false;
  }
  token: any;
  checkExpression: any;
  public apiEndpoint: string = '';

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
    super(locator, route);
    let _self = this;

    if (route.snapshot.paramMap.get('id'))
      _self.uiformId = Number(route.snapshot.paramMap.get('id'));
      _self.token = this.route.snapshot.queryParamMap.get('token');
    _self.locator.config
      .getProperty('endpoint.ui.public.form')
      .then((property: string) => {
        _self.apiEndpoint = property;
        _self.initApiEndpoint(property);
      });
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  override ngOnInit() {
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.ui.public.form')
      .then((property: string) => {
      // _self.initApiEndpoint(property);
      if (_self.uiformId !== null && _self.uiformId !== undefined) {
        console.log("_self.uiformId",_self.uiformId)
         _self.getData(_self.uiformId!)
      }
    });
}

 public getData(id: any) {
    let _self = this;
    console.log("id",id)
    let url =
      _self.locator.config.get('endpoint.ui.public.form') +
      '/' + 'get' +"/" +
      id;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
        
      if (res.success) {       
        _self.form.data = res.result['data'];
            _self.usecaseId = _self.form.data.userstoryId;
             _self.getUsecaseAttribute();
             _self.getUsecase();
       
        setTimeout(() => {
          _self.getUsecasePreloadData()
          _self.setDefaultvalue();
        },2000)
         
       
      } else {
        alert('Error: ' + res.message);
      }
          });
        }
  override get(id: number, callback?: any): void {
         
  }

  addRulesEvents(): void {
    if (!this.form?.data?.fields) return;

    let fields = this.form.data.fields.filter(
      (field: any) => field.rule && field.rule !== ''
    );

    // Ensure elements are ready before binding events
    fields.forEach((field: any) => {
      const inputElement = document.querySelector(`input[id="${field.code}"]`);

      if (inputElement) {
        this.renderer.listen(inputElement, 'change', (event: Event) => {
          this.handleRuleExecute(field, event);
        });

        this.renderer.listen(inputElement, 'input', (event: Event) => {});
      } else {
        console.error(`Input element with id "${field.code}" not found`);
      }
    });
  }

  handleRuleExecute(field: any, event: any) {
    let _self = this;
    let ruleData: any;
    _self.entryform['error'] = [];
    _self.entryform['message'] = '';
    _self.entryform['inputerror'] = [];
    ruleData = { ..._self.entryform.data };
    //ruleData = _self.entryform.data;
    ruleData['collectionName'] = _self.usecase['collectionName'];

    let url: any =
      _self.locator.config.get('endpoint.application.rules') +
      '/' +
      'execute/' +
      field.rule;

    _self.locator.http.post(url, ruleData, function (res: any, error: any) {
      if (error) {
        return;
      }
      _self.entryform.data = { ..._self.entryform.data, ...res.result };
      _self.entryform['error'] = !res.success;
      _self.entryform['message'] = res.message;
      _self.entryform['inputerror'] = Object.values(
        res.result['inputerror']
      ).join(', ');
    });
  }

  checkRuleExecute(code: any) {
    let fields = this.form.data.fields.filter(
      (field: any) => field?.rule && field?.rule !== '' && field?.code == code
    );
    fields.forEach((field: any) => {
      this.handleRuleExecute(field, null);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['form'] && this.form?.data?.fields) {
      //this.addRulesEvents();
    }
  }

  ngAfterViewInit() {}

  private listenerAdded = false;

  // ngAfterViewChecked(): void {
  //   if (!this.listenerAdded) {
  //     setTimeout(() => {
  //       this.addRulesEvents();
  //       this.addParentFilter();
  //     }, 1000);

  //     this.listenerAdded = true;
  //   }
  // }

  override populateForm(form: any, data: any): void {
    super.populateForm(form, data);

    if (data.groupLabels) {
      form.groupLabels = data.groupLabels;
    }
    if (data.childFormList) {
      form.childFormList = data.childFormList;
    }
  }

  getRows(field: any) {
    if (field['rowsize'] && field['rowsize'] > 1 && field['rowsize'] < 4) {
      return 'row-size-' + field['rowsize'];
    }
    return '';
  }

  getColums(columns: any, field: any) {
    let size = 12;
    if (columns) {
      size = 12 / columns;
    }
    if (field['colsize'] && field['colsize'] > 0) {
      let tempSize = size * field['colsize'];
      if (tempSize <= 12) {
        return tempSize;
      } else {
        return 12;
      }
    }
    return size;
  }

  getDescription(field: any) {
    if (field['description']) {
      return field['description'];
    }

    return field['label'];
  }

  gettitle(field: any) {
    if (field['description']) {
      return this.form.data['description'];
    }
    return this.form.data['title'];
  }

  getAttributeLable(lable: string) {}

  public attributeList: any = [];

  /**
   * only filter attribute that exist in usecase
   * @param data = responce get from server
   */
  cleanAndSetData(data: any) {
    let _self = this;
    const sanitizedItem: any = {};
    _self.usecaseAttributes.forEach((attr: any) => {
      let key = attr['code'];
      if (key in data) {
        sanitizedItem[key] = data[key];
      }
    });
    if ('id' in data) {
      sanitizedItem['id'] = data['id'];
    }
    _self.entryform['data'] = sanitizedItem;
  }

  combobox: any = [];
  public saveUiformData() {
    let _self = this;
    _self.entryform['error'] = [];
    _self.entryform['message'] = '';
    _self.entryform['inputerror'] = [];
    let url =    
      _self.getAPIBaseUrl(_self.form.data.code + '/saveForm')
    

    if (this.token) {
     url += `?token=${encodeURIComponent(this.token)}`;
}
    _self.combobox = _self.usecaseAttributes.filter(
      (item: any) => item.type === 'combobox'
    );
    
    const entryformLabels = Object.keys(_self.entryform['data']);

    _self.combobox.forEach((item: any) => {
      if (entryformLabels.includes(item.code)) {
        const entryValue = _self.entryform['data'][item.code];
        if (entryValue && !item.values.includes(entryValue)) {
          let isValid = true;
          if (item.regex) {
            const regex = new RegExp(item.regex);
            isValid = regex.test(entryValue);
          }

          if (isValid) {
            item.values.push(entryValue);
          }

          // Prepare data to send to API
          const payload = {
            label: item.label,
            type: item.type,
            userstoryId: item.userstoryId,
            id: item.id,
            values: item.values,
          };

          // Define API endpoint
          let url =
            _self.locator.config.get('endpoint.userstory.attributes') + '/save';

          // Make API call to save updated combobox
          _self.locator.http.post(url, payload, (res: any, error: boolean) => {
            if (error) {
              alert('Server Error: ' + error);
              return;
            }
          });
        }
      }
    });

    _self.entryform['data'] = this.removeEmptyAttributes(
      _self.entryform['data']
    );

    _self.locator.http.post(
      url,
      _self.entryform['data'],
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.entryform['error'] = !res.success;
        _self.entryform['message'] = res.message;
        _self.entryform['inputerror'] = res.result?.inputerror || {};
        if (res.result['inputerror']) {
          if (res.result['inputerror']['key']) {
            _self.entryform['message'] = res.result['inputerror']['key'];
          } else {
            _self.entryform['inputerror'] = res.result['inputerror'];
          }
        }
      

        if (res.success) {

          _self.entryform['data']['id'] = res.result['data']['id'];
          _self.id = res.result['data']['id'];

  const hasImages = _self.imageFiles && Object.keys(_self.imageFiles).length > 0;
  const hasDocs = _self.docFiles && Object.keys(_self.docFiles).length > 0;


          if (hasImages && hasDocs) {
    console.log('Uploading images and documents...');
            _self
              .uploadImagesThenSaveForm(_self.imageFiles)
      .then(() => {        
        return _self.uploadImagesThenSaveForm(_self.docFiles);
      })
      .then(() => {      
        return _self.finalSubmitForm();
      })
              .catch((err) => {
                console.error('Upload failed:', err);
                alert('File upload failed.');
              });

          } else if (hasImages) {
            _self
              .uploadImagesThenSaveForm(_self.imageFiles)
      .then(() => {
        return _self.finalSubmitForm();
      })
              .catch((err) => {
                alert('Image upload failed.');
              });

          } else if (hasDocs) {
               _self
              .uploadImagesThenSaveForm(_self.docFiles)
      .then(() => {
        return _self.finalSubmitForm();
      })
              .catch((err) => {
                alert('Document upload failed.');
              });

  } else {
    _self.finalSubmitForm();
          }
} else {
  alert('Form submission failed.');
        }

      }
    );
  }

 private removeEmptyAttributes(data: any): any {
    const cleanedData: any = {};
    for (const key in data) {
      if (data[key] !== '' && data[key] !== null && data[key] !== undefined) {
        cleanedData[key] = data[key];
      }
    }
    return cleanedData;
  }

 override getUsecase() {
    let _self = this;
    let url =
      _self.locator.config.get('endpoint.ui.public.form') +
      '/getUsecase/' +
      _self.usecaseId;
    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.usecase = res.result.data;
      if (_self.appId === 0) {
        _self.appId = _self.usecase['appId'];
      }
      let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');
      _self.apiurl =
        _self.locator.config.get('endpoint.api.v1') + '/' + updatedName;
      
    });
 }

  uploadImagesThenSaveForm(Files: any): Promise<void> {
    let _self = this;

    const fileKeys = Object.keys(Files);
    const uploadPromises = fileKeys.map((code) => {
      const file = Files[code];
      return _self.uploadFileToServer(file, code, 0); // Assume this returns a Promise
    });

    return Promise.all(uploadPromises).then((responses) => {
      responses.forEach((response: any, index: number) => {
        const imageId = response.result?.data?.imageId;
        if (imageId) {
          _self.entryform['data'][fileKeys[index]] = imageId;
        }
      });
    });
  }

  // Final function to submit the form with image IDs
  finalSubmitForm() {
    let _self = this;
    let url = _self.urlRewrite(
      _self.getAPIBaseUrl(_self.form.data.code + '/saveForm')
    );
   if (this.token) {
     url += `?token=${encodeURIComponent(this.token)}`;
     }
    _self.locator.http.post(
      url,
      _self.entryform['data'],
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error: ' + error);
          return;
        }

        _self.entryform['error'] = !res.success;
        _self.entryform['message'] = res.message;

        if (res.success) {
          _self.entryform['data']['id'] = res.result['data']['id'];
          _self.id = res.result['data']['id'];

          // Optionally handle further logic after the final form submission
          console.log('Final form saved successfully with image IDs:', res);
        } else {
          alert('Error while submitting form with image IDs');
        }
      }
    );
  }

  toggleDropdown(e: any) {
    if (
      e['readOnly'] ||
      (e.allowChangeAfterInitial == 1 && this.entryform.data['id'] > 0)
    ) {
      return;
    }
    e.isDropdownOpen = !e.isDropdownOpen;
  }

  onCheckboxChange(e: any, option: any, event: any) {
    event.stopPropagation();
    if (!this.entryform.data[e.code]) {
      this.entryform.data[e.code] = [];
    }
    if (event.target.checked) {
      if (!this.entryform.data[e.code].includes(option)) {
        this.entryform.data[e.code].push(option);
      }
    } else {
      this.entryform.data[e.code] = this.entryform.data[e.code].filter(
        (o: any) => o !== option
      );
    }
    this.onChange(e, this.entryform.data[e.code]);
  }

  getSelectedText(e: any) {
    const value = this.entryform.data[e.code];
    if (e['multipleSelect'] == 1 && Array.isArray(value) && value.length) {
      return value.join(', ');
    }
    return '';
  }

  public onChange(e: any, val: any) {
    let _self = this;
    let l = _self.form.preload[e['primaryUsecase']];
    let col = e['depAttribute'];
    for (let i = 0; i < l.length; i++) {
      if (l[i]['id'] == val.target.value) {
        _self.entryform.data[col] = l[i]['name'];
      }
    }
    //Check Primary Usecase Dependency Filter
    if (
      _self.usecase !== undefined &&
      _self.usecase?.parentUsecaseDependency !== undefined &&
      _self.usecase?.parentUsecaseDependency?.[e['primaryUsecase']] !==
        undefined
    ) {
      _self.primaryUsecaseDependencyFilter(
        _self.usecase['parentUsecaseDependency'][e['primaryUsecase']],
        val
      );
    }
  }

  /***
   * primaryUsecaseDependencyFilter
   */
  primaryUsecaseDependencyFilter(data: any, val: any) {
    let _self = this;
    let key = val['target']['id'];
    let [appCode, codes] = (data['code'] ?? '').toString().split('.');
    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/' +
      appCode +
      '/' +
      codes +
      '/preloadData';
    let searchParams = {
      val: `${key}=${
        isNaN(val['target']['value'])
          ? val['target']['value']
          : Number(val['target']['value'])
      }`,
    };
    _self.locator.http.post(
      url,
      searchParams,
      function (res: any, error: boolean) {
        if (error) {
          _self.entryform['error'] = true;
          _self.entryform['message'] = error;
          return;
        }
        _self.form.preload[data['code']] = res.result[data['code']];
      }
    );
  }

  onSave() {
    //this.entryform.data['uiformId'] = this.form.data['id'];
    this.saveUiformData();
    this.isSubmitted = true;
  }

  onCancel() {
    // nothing do
    // this.forward('/uiform/' + this.uiformId);
    this.resetUiformData();
    this.setDefaultvalue();
  }

  onList() {
    // go to list page
    // this.forward('/uiformlist/' + this.uiformId);
  }

  onDelete() {
    this.deleteUseCaseData(this.id, () => {
      this.resetUiformData();
    });
  }

  onNew() {
    this.resetUiformData();
    this.setDefaultvalue();
    this.imageFiles = {};
    this.docFiles = {};
    this.imagePreviews = {};
    this.fileErrors = {};
    this.imageSizes = {};
    this.resetImgDoc();

     this.entryform['error'] = [];
     this.entryform['message'] = '';
     this.entryform['inputerror'] = [];
  }

  resetUiformData() {
    this.isSubmitted = false;
    let _self = this;
    _self.entryform['data'] = {};
  }

  getAttributeByUniqueId(fieldId: number) {
    return this.usecaseAttributes.find(
      (attr: any) =>
        attr.id === fieldId && attr['system'] != 1 && attr['unique'] == 1
    );
  }

  isAttributeHaveUnique() {
    return this.usecaseAttributes.find((attr: any) => attr['unique'] == 1);
  }

  onValueChange(e: any, value: string) {
    this.searchform.data[e.code] =
      e.type === 'number' ? parseFloat(value) : value;
  }

  onReferenceValueChange(e: any, value: string) {
    this.searchform.data[e.code] = parseFloat(value);
  }

  fieldButtonSubmit(button: string) {
    let _self = this;

    if (button === 'save') {
      _self.onSave();
    }

    if (button === 'cancel') {
      _self.onCancel();
    }

    // if (button === 'list') {
    //   _self.onList();
    // }

    // if (button === 'delete') {
    //   _self.onDelete();
    // }

    if (button === 'new') {
      _self.onNew();
    }
  }

  getDefaultColums(columns: any, field: any) {
    let size = 12;
    if (columns) {
      size = 12 / columns;
    }
    return 12;
  }

  getTruncateLimit(columns?: number): number {
  if (!columns || columns <= 1) return 150;
  if (columns === 2) return 70;
  if (columns === 3) return 35;
  if (columns === 4) return 25;
  return 15; 
}

  public getInputError(name: string) {
    let _self = this;
    let errMsg = '';
    let ie = _self.entryform['inputerror'];
    if (ie && ie[name]) {
      errMsg = ie[name];
    }
    return errMsg;
  }

  // Function to clear error on input
  clearInputError(code: string) {
    if (this.entryform.inputerror?.[code]) {
      delete this.entryform.inputerror[code];
    }
  }

  public clearUniqueMessage(name: string) {
    let _self = this;
    let errMsg = '';
    _self.form['inputerror'][name] = '';
  }

  resetShareForm() {
    let _self = this;
    _self.sform = {
      data: {},
    };
    _self.datavalidate = false;
  }

  public sform: any = {
    data: {},
  };

  imagePreview: string | ArrayBuffer | null = null;

  /**
   * Get Thumbnail of the image
   * @param logo
   * @returns
   */
  getDocThumbnailImage(logo: any) {
    return this.getDocThumbnail(logo);
  }

  getGroupsField(label: any) {
    return this.form.data.fields.filter((field: any) => field.group == label);
  }

  checkTime(group: any): boolean {
    const startRaw = group.allowedTimeStart;
    const endRaw = group.allowedTimeEnd;
    const startMeridian = group.allowedTimeStartMeridian;
    const endMeridian = group.allowedTimeEndMeridian;

    // If all are null/empty → treat as unrestricted
    if (!startRaw && !endRaw && !startMeridian && !endMeridian) {
      return true;
    }

    // If any required part is missing → restrict access
    if (!startRaw || !endRaw || !startMeridian || !endMeridian) {
      return false;
    }

    // Convert time string (hh:mm) and meridian into minutes
    const toMinutes = (timeStr: string, meridian: string): number | null => {
      const [hh, mm] = timeStr.split(':').map(Number);
      if (isNaN(hh) || isNaN(mm)) return null;

      let hour = hh;
      if (meridian === 'PM' && hh !== 12) hour += 12;
      if (meridian === 'AM' && hh === 12) hour = 0;

      return hour * 60 + mm;
    };

    const startMinutes = toMinutes(startRaw, startMeridian);
    const endMinutes = toMinutes(endRaw, endMeridian);

    // If invalid parsed time → restrict
    if (startMinutes === null || endMinutes === null) {
      return false;
    }

    // Get current time in minutes
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // Check if current time falls within the allowed range
    return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
  }

  getFieldNotIngroup() {
    return (
      this.form?.data?.fields?.filter(
        (field: any) => !field?.group && field?.group == null
      ) || []
    );
  }

  override  getUsecaseAttribute(getdata: boolean = true, callback?: any) {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.ui.public.form') +
      '/list/' +
      _self.usecaseId;
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.usecaseAttributes = res.result.data;
      if (
        _self.usecaseAttributes?.length > 0 &&
        Array.isArray(_self.form?.data?.fields)
      ) {
        _self.usecaseAttributes.forEach((attribute: any) => {
          const matchingField = _self.form.data.fields.find(
            (field: any) => field.id === attribute.id
          );
          if (matchingField) {
            attribute.label = matchingField.label;
            attribute.listView = matchingField?.listView;
          }
          const conditionMet = _self.usecaseAttributes.some(
            (e: any) => e.depAttribute === attribute['code']
          );
          if (conditionMet) {
            let depAttribute = attribute;
            _self.parentUsecaseList.push(depAttribute);
          }
        });
      } else {
        console.warn('fields is undefined or not an array', _self.form?.data);
      }

      // _self.afterUsecaseAttrGet();
      // if (getdata) {
      //   _self.getUsecaseDataList(callback);
      // } else if (callback) {
      //   callback();
      // }
    });
  }

  override getAttributeById(fieldId: number) {

    console.log(this.usecaseAttributes);
    return this.usecaseAttributes?.find(
      (attr: any) => attr.id === fieldId && attr['system'] != 1
    );
  }
  evaluateCondition(attr: any): boolean {
    try {
      if (attr['show']) {
        const condition = attr['show'];
        const context = this.entryform.data; // Assuming `this.form` is the context containing the variables
        // Create a new Function that safely evaluates the condition
        const fn = new Function(
          ...Object.keys(context),
          `return ${condition};`
        );
        return fn(...Object.values(context));
      }
      return true; // Return true if no condition is provided
    } catch (error) {
      console.error('Error evaluating condition:', error);
      return false; // Return false if an error occurs
    }
  }

  evaluateCondition1(attr: any): boolean {
    try {
      // Safely evaluate the condition with necessary context
      // const context = this.entryform?.data || {};
      if (attr['show']) {
        return eval(attr['show']);
      } else {
        return true;
      }
    } catch (error) {
      console.error('Error evaluating condition:', error);
      return false;
    }
  }

  groupFieldsByGroup(fields: any[]): { [key: string]: any[] } {
    return fields.reduce((acc, field) => {
      const group = field['group'] || 'Ungrouped'; // Default to 'Ungrouped' if no group name exists
      acc[group] = acc[group] || [];
      acc[group].push(field);
      return acc;
    }, {});
  }

  /**
   * If Date clear change Form
   * @param event
   * @param code
   * @param type
   */
  onDateChange(event: any, code: string, type: string) {
    if (type === 'date') {
      const selectedDate = event.target.value;
      this.entryform.data[code] = selectedDate ? selectedDate : null;
    }
  }

  /**
   *
   * @param event
   * @param e
   * @param placeValue
   * @returns
   */
  restrictDecimalPlaces(event: Event, e: any, placeValue: number): void {
    const input = event.target as HTMLInputElement;
    if (!input.value) {
      return;
    }
    const value = input.value;
    const parts = value.split('.');

    if (parts.length === 2 && parts[1].length > placeValue) {
      this.entryform['error'] = true;
      this.entryform['message'] =
        'Only ' + placeValue + ' decimal value allowed on ' + e.label;
      this.entryform.data[e.code] = `${parts[0]}.${parts[1].substring(
        0,
        placeValue
      )}`;
      input.value = `${parts[0]}.${parts[1].substring(0, placeValue)}`;
    }
  }

  enforceMaxDate(event: Event, fieldCode: string, fieldType: string): void {
    if (fieldType === 'date') {
    const input = event.target as HTMLInputElement;
    const maxDate = new Date('9999-12-31');
    const enteredDate = new Date(input.value);

    // If invalid or too large, reset
    if (enteredDate > maxDate) {
      input.value = '9999-12-31';
      this.entryform.data[fieldCode] = '9999-12-31';
    } else {
      this.entryform.data[fieldCode] = input.value;
    }
  }
  }

  /***
   * Filter The ParentUsecase With Type
   */
  addParentFilter(): void {
    if (!this.form?.data?.fields) return;
    let fields = this.form.data.fields.filter(
      (field: any) => field.parentFilter && field.parentFilter !== ''
    );

    const code = fields[0]?.code;
    let matchingUsecase = null;
    let matchingKey = null;
    if (
      this.usecase.parentUsecases &&
      typeof this.usecase.parentUsecases === 'object'
    ) {
      for (const key of Object.keys(this.usecase.parentUsecases)) {
        const parentUsecase = this.usecase.parentUsecases[key];
        if (parentUsecase && parentUsecase.id === code) {
          matchingUsecase = parentUsecase;
          matchingKey = key;
          break;
        }
      }
    }

    if (matchingUsecase) {
      // this.preloadListData(matchingKey, fields[0]?.parentFilter);
    } else {
      console.error('Not found in parentUsecases');
    }
  }

  override getUsecasePreloadData() {
    let _self = this;
   let url =
     _self.getAPIBaseUrl('preloadServer') + '/' + _self.uiformId
      if (this.token) {
     url += `?token=${encodeURIComponent(this.token)}`;
     }
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.form['preload'] = res.result;
    });
  }

  /**
   * Preload Data with SearchParam
   * @param data
   * @param val
   */
  preloadListData(data: any, val: any) {
    let _self = this;

    let searchParams: { [key: string]: string } = {};

    searchParams['val'] = val;

    let [appCode, codes] = (data ?? '').toString().split('.');
    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/' +
      appCode +
      '/' +
      codes +
      '/preloadData';

    _self.locator.http.post(
      url,
      searchParams,
      function (res: any, error: boolean) {
        if (error) {
          _self.entryform['error'] = true;
          _self.entryform['message'] = error;
          return;
        }
        _self.form.preload[data] = res.result[data];
      }
    );
  }

  //--------------------------------------ADD PAGE COMMENT--------------------------------------

  commentform: any = {
    error: true,
    message: '',
    data: { id: 0 }, //form data
  };

  uploadFileToServer(file: File, code: string, imageId: any): Promise<any> {
    if (imageId === null || imageId === undefined) {
      imageId = 0;
    }

  let url = this.getAPIBaseUrl(
      `doc/${this.entryform.data['id']}/${imageId}/${code}`
    );

     if (this.token) {
     url += `?token=${encodeURIComponent(this.token)}`;
     }
    const param = { id: this.form.data.id };

    return new Promise((resolve, reject) => {
      this.locator.http.postMutipart(
        url,
        param,
        file,
        (res: any, error: any) => {
          if (error) {
            reject(error);
          } else {
            this.entryform.error = !res.success;
            this.entryform.message = res.result.message;
            if (res.success) {
              this.entryform.message = 'File is uploaded';
              this.entryform.data[code] = res.result.data[code];
              this.changeDoc();
              this.getDoc(this.entryform.data[code]);
              this.cdRef.detectChanges();
            }
            resolve(res);
          }
        }
      );
    });
  }
  //--------------------------------------Add Page Attachment--------------------------------------
  imageAttachmentPreview: string | ArrayBuffer | null = null;

  attachmentform: any = {
    error: true,
    message: '',
    data: { id: 0 }, //form data
  };

  getInitials(fullName: string): string {
    if (!fullName) return '';

    // Split the name at uppercase letters or space
    const words = fullName.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');

    // Get the first character of the first and second words (if available)
    const initials = words
      .slice(0, 2)
      .map((word) => word.charAt(0).toUpperCase())
      .join('');

    return initials;
  }

  public datavalidate = false;
  public btnDisable = true;

  checkEmail(email: any) {
    let _self = this;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      console.error('Email is not valid');
      _self.form.error = true;
      _self.datavalidate = true;
      _self.btnDisable = true; // ❗ Disable the button when email is invalid
      _self.form.inputerror['email'] = 'Email not valid';
      return;
    } else {
      _self.form.error = false;
      _self.datavalidate = false;
      _self.btnDisable = false; // ✅ Enable the button when email is valid
    }
  }

  trackByFn(index: number, item: any) {
    return item.id; // Make sure each item has a unique id
  }

  setDefaultvalue() {
    this.usecaseAttributes.forEach((item: any) => {
      if (item.type === 'date' && item.defaultToCurrentDate) {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const formattedDate = `${year}-${month}-${day}`;
        this.entryform.data[item.code] = formattedDate;
      }
      if (item.type === 'time' && item.defaultToCurrentTime) {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const formattedTime = `${hours}:${minutes}`;
        this.entryform.data[item.code] = formattedTime;
      }

      if (item.defaultValue) {
        this.entryform.data[item.code] = item.defaultValue;
      }
    });
  }

  location = '';
  latitude = 0;
  longitude = 0;

  onLatLngChange(code: string) {
    alert('on late ');
    // Optional: Add validation or logic if needed when user types values
    console.log('-----uiform data ------', this.entryform.data);
    const lat = this.entryform.data[code]?.lat;
    console.log('lat values ---- ', lat);
    const lng = this.entryform.data[code]?.lng;
    console.log('lat lnt ---- ', lat);
    if (lat && lng) {
      // You can trigger anything here if needed
      console.log('Lat/Lng manually updated:', lat, lng);
    }
  }

  defaultLat = 28.6139; 
  defaultLng = 77.209;
  activeMapCode: string | null = null;

  setCurrentLocation(code: string) {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          if (!this.entryform.data[code]) {
            this.entryform.data[code] = {};
          }

          this.entryform.data[code].lat = lat;
          this.entryform.data[code].lng = lng;

          console.log(`📍 Location set: Lat = ${lat}, Lng = ${lng}`);
        },
        (error) => {
          console.error('❌ Geolocation error:', error);
          alert(
            'Unable to get your location. Please allow location access in the browser.'
          );
        }
      );
    } else {
      alert('Geolocation is not supported by your browser.');
    }
  }

  viewOnMap(code: string) {
    const location = this.entryform.data[code];
    const lat = location?.lat;
    const lng = location?.lng;

    if (lat && lng) {
      const mapUrl = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(mapUrl, '_blank');
    } else {
      alert('Location not available. Please set the location first.');
    }
  }

  clearLocation(code: string) {
    if (this.entryform.data[code]) {
      this.entryform.data[code].lat = null;
      this.entryform.data[code].lng = null;
    }
  }
 override getAPIBaseUrl(suburl?: string) {
    let _self = this;
   let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');
   console.log("updatedName",updatedName)
    let url = _self.locator.config.get('endpoint.ui.public.form') + '/' + updatedName;
    if (suburl) {
      url += '/' + suburl;
    }
    return url;
  }
  public resetImgDoc(){
  this.imageFiles = {};
  this.docFiles = {};
  this.imagePreviews = {};
  this.fileErrors = {};
  this.imageSizes = {};
  this.DocPreviews = {};
  const fileInputs = document.querySelectorAll('input[type="file"]');
       fileInputs.forEach((input) => {
       (input as HTMLInputElement).value = '';
    });
  }

  onFileChooseClicked(fileInput: any, code: any) {
    if (fileInput) {
      fileInput.value = '';
    }
    this.imageSizes[code] = false;
    this.imagePreviews[code] = null;
    this.fileErrors[code] = false;
}

imageFiles: { [key: string]: File } = {};
docFiles: { [key: string]: File } = {};

imagePreviews: { [key: string]: string | ArrayBuffer | null } = {};
fileErrors: { [key: string]: boolean } = {};
imageSizes: { [key: string]: boolean } = {};
onImageFileChanged(event: any, e: any, imageId: any) {

  console.log("e-->",e);
  let code =e.code;
 // console.log("code",e.size);

  const file = event.target.files[0];
  console.log("image type :: ",file.type);
  
  if (!file) return;
  // Validate file type
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
  if (!allowedTypes.includes(file.type)) {
    this.fileErrors[code] = true;
    this.imageSizes[code] = false;
    this.imagePreviews[code] = null;
    return;
  } else {
    this.fileErrors[code] = false;
  }
   
  
if (e.size) {
  const maxSizeImg = e.size;
  const maxFileSizeInBytes = maxSizeImg * 1024 * 1024;

  if (file.size > maxFileSizeInBytes) {
    this.imageSizes[code] = true;
    this.fileErrors[code] = false;
    this.imagePreviews[code] = null;
    console.warn(`File size too large. Limit: ${maxSizeImg} MB`);
    return;
  } else {
    this.imageSizes[code] = false;
  }
} else {
  // No size restriction
  console.log('No size limit specified, allowing any image size.');
  this.imageSizes[code] = false;
}


  // Step 1: Show Preview First
  const reader = new FileReader();
  reader.onload = (e) => {
    this.imagePreviews[code] = e.target?.result as string;
    this.cdRef.detectChanges();  
    this.imageFiles[code] = file;
    
  };
  reader.readAsDataURL(file);
} 

DocPreviews: { [key: string]: string | ArrayBuffer | null } = {};
docFileErrors: { [key: string]: boolean } = {};
docSizes: { [key: string]: boolean } = {};

public onFileChanged(event: any, e: any, imageId: any) {
   const code = e.code;
    const fileObj = event.target.files[0];
    var _self = this;
    if (imageId === null || imageId === undefined) {
      imageId = 0;
  }  
    

const allowedDocTypes = [
  'image/jpeg', 
  'image/jpg', 
  'image/png', 
  'image/gif',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
];

  
  if (!allowedDocTypes.includes(fileObj.type)) {
    this.docFileErrors[code] = true;
    this.docSizes[code] = false;
    this.DocPreviews[code] = null;
    return;
  } else {
    this.docFileErrors[code] = false;
  }

  const maxSizeDoc = e.size || 1;
  const maxFileSizeInBytes = maxSizeDoc * 1024 * 1024;
  if (fileObj.size > maxFileSizeInBytes) {
    this.docSizes[code] = true;
    this.docFileErrors[code] = false;
    this.DocPreviews[code] = null;
    return;
  } else {
    this.docSizes[code] = false;
  }
this.docFiles[code] = fileObj;
const reader = new FileReader();
  reader.onload = (e) => {
    this.DocPreviews[code] = e.target?.result as string;
    this.cdRef.detectChanges();  
    this.docFiles[code] = fileObj;
  };
  reader.readAsDataURL(fileObj); 
}
  
  override getDocThumbnail(skey: number) {
    if (!skey) {
      skey = 0;
    }
    let docAPI = this.locator.config.get("DOC_API");
    return docAPI + "th/" + skey + "?t=" + this.imageTimestamp;;
  }

  resetFormAndRedirect() {
      this.resetUiformData();
      this.setDefaultvalue();
      this.isSubmitted = false;
    }
}
